

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Select & Add Participants
    <button mat-icon-button (click)="closeSelectParticipant()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <div class="signaturePanel">

      <div class="esign">
        <div class="panel" *ngIf="participantMessageInfo!=null">
          <div class="example-list">
          </div>
          <div class="groupHolder">
            <div cdkDropList class="example-list">
              <div class="groupheading" (click)="getToogleInformation()">
                <h2>
                  <mat-icon>message</mat-icon>Information
                </h2>
                <button mat-icon-button> <mat-icon>expand_more</mat-icon> </button>
              </div>

              <div id="participantMessageDiv" [ngClass]="{'active' : toogleInformation}"
                innerHtml="{{participantMessageInfo}}"></div>

            </div>
          </div>
        </div>
        <div class="panel" cdkDropListGroup>

          <!-- <mat-form-field class="" appearance="fill">
            <mat-label>Project</mat-label>
            <input matInput placeholder="Enter project name" value="">
          </mat-form-field> -->

          <div class="groupHolder" *ngFor="let p1 of projectGroups">

            <div cdkDropList id="{{p1.groupName}}" [cdkDropListData]="p1.projGrpRelationParticipantList"
              class="example-list">

              <div class="groupheading">
                <h2 *ngIf="p1.groupType ==1">
                  <mat-icon>create</mat-icon>{{p1.groupName}}
                </h2>

                <h2 *ngIf="p1.groupType !=1">
                  <mat-icon>description</mat-icon>{{p1.groupName}}
                </h2>

              </div>

              <div *ngIf="p1.projGrpRelationParticipantList.length == 0" class="moveblock example-box">
                <p class="nocontent">No relationship added</p>
              </div>

              <div *ngFor="let p of p1.projGrpRelationParticipantList" class="moveblock example-box" cdkDrag>

                <div class="DragIcon" cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </div>

                <div class="Colrd" [ngStyle]="{'background-color': p.colourCode }">
                  <mat-icon *ngIf="p.typeOfParticipant==0">email</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==4">person</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==5">work</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==1">app_registration</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==2">contact_mail</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==3">business</mat-icon>
                </div>

                <div class="userInfo">
                  <div class="chipss">
                    <mat-chip-list>
                      <mat-chip> {{p.relationName}} </mat-chip>
                    </mat-chip-list>
                  </div>


                  <div class="selectContact" *ngIf="p.participantName || p.roleName || p.contactEmail">
                    <div class="userpic" *ngIf="p.participantImageURL">
                      <img [src]="p.participantImageURL" alt="" />
                    </div>

                    <div class="userpic" *ngIf="!p.participantImageURL">
                      <span class="shortName" *ngIf="p.participantName">{{getShortName(p.participantName)}}</span>
                      <span class="shortName" *ngIf="p.roleName">{{getShortName(p.roleName)}}</span>
                      <span class="shortName" *ngIf="p.contactEmail">{{getShortName(p.contactEmail)}}</span>
                    </div>

                    <div class="info">
                      <p *ngIf="p.participantName">{{ p.participantName }} </p>

                      <p *ngIf="p.roleName">{{ p.roleName }} </p>
                      <p *ngIf="p.typeOfParticipant==0">{{p.contactEmail}}</p>
                      <p class="emailID" *ngIf="p.typeOfParticipant!=0">{{ p.participantEmail }} </p>
                    </div>


                    <button class="removeContact" mat-icon-button color="basic" (click)="RemoveRelation(p,p1)">
                      <mat-icon>close</mat-icon>
                    </button>

                  </div>

                  <ng-container *ngIf="!p.participantName && !p.roleName &&  !p.contactEmail">
                    <button mat-icon-button color="primary" class="personadd"
                      (click)="assignUserNew(true,false,'',p,p1)">
                      <mat-icon>person_add</mat-icon>
                    </button>
                    <!-- <button mat-icon-button color="primary" class="personadd"
                      (click)="assignUser(addAssigne,true,false,'',p,p1)">
                      <mat-icon>person_add</mat-icon>
                    </button> -->
                  </ng-container>



                </div>
                <div class="Cancel">
                  <span class="approver" *ngIf="p.isApprover==true">Approver</span>
                </div>

                <ng-container *ngIf="p.selectedContactFieldEmailID.length>1">
                  <div class="partdrop">
                    <mat-form-field>
                      <mat-label>Select {{ContactNames}}</mat-label>
                      <mat-select (selectionChange)="onSelectContact($event,p.relationName,p,p1)">
                        <mat-option *ngFor="let role of p.selectedContactFieldEmailID" [value]="role.name">
                          {{role.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                </ng-container>

              </div>


            </div>

          </div>

        </div>
      </div>

    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="basic" (click)="closeSelectParticipant()">Cancel</button>
    <span>
     <button  class="btn-green mr-5" (click)="openProject()">Edit Form</button>
      <button mat-flat-button color="primary" [disabled]="!SendButtonDisabled" (click)="ProjectSend()">Send</button>
    </span>
  </mat-dialog-actions>

